export const isKosekTeam = () =>
  window.location.href.includes("kosekteam") ||
  window.location.pathname === "/";
